<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Usuário</span>
        <h3 class="page-title">Adicionar</h3>
      </d-col>
    </d-row>

    <!-- Content -->
    <user-account-details/>
  </d-container>
</template>

<script>
import Events from '_utils/events';
import UserAccountDetails from '_modules/user/components/UserAccountDetails.vue';

export default {
  name: 'user-create',
  components: {
    UserAccountDetails,
  },
  computed: {
  },
  data() {
    return {};
  },
  created() {
    Events.$emit('sidebarVisible', false);
  },
};
</script>

